import React from 'react'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import "./style.scss"
import clsx from "clsx";

type VariationPlacement =
  "top-start"
  | "top-end"
  | "bottom-start"
  | "bottom-end"
  | "right-start"
  | "right-end"
  | "left-start"
  | "left-end";
type BasePlacement = "top" | "bottom" | "right" | "left";
type AutoPlacement = "auto" | "auto-start" | "auto-end";
export type Placement = AutoPlacement | BasePlacement | VariationPlacement;

interface IProps {
  children: any;
  title: string | JSX.Element | React.ReactNode;
  className?: string;
  placement?: Placement;
  delay?: number;
}

function OCTTooltip(props: Readonly<IProps>) {
  let {children, title, className, placement} = props

  return (
    <OverlayTrigger
      placement={placement || "top"}
      trigger={['hover', 'focus']}
      rootClose
      delay={{ show: 0.3, hide: 0.3 }}
      overlay={
        <Tooltip id="tooltip" className={clsx("custom-tooltip text-navy", className,)}>
          {title}
        </Tooltip>
      }
    >
      {children}
    </OverlayTrigger>
  )
}

export default OCTTooltip